const Auth = {
  _token: null,
  _key: "gqltoken",
  onLogin: token => {
    Auth.setToken(token)
  },

  onLogout: () => {
    Auth.removeToken()
  },
  removeToken: () => {
    localStorage.removeItem(Auth._key)
  },
  setToken: token => {
    localStorage.setItem(Auth._key, token)
  },
  getToken: () => {
    return localStorage.getItem(Auth._key)
  }
}

export default Auth
